export default "__VITE_ASSET__Dzs8wO4p__"